<template>
  <div class="stash">
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </b-card>
      </template>

      <div class="row">
        <div class="col-xl-4">
          <Card1 />
        </div>

        <div class="col-xl-8">
          <Card2 :stashCount="stashAccounts.length" />
        </div>
        <StashInfo
          v-if="stashAccounts && stashAccounts.length > 0"
          v-for="stashAccount in stashAccounts"
          :key="`${stashAccount.id}`"
          :stashAccount="stashAccount"
          :stashServiceDetail="stashServiceDetail"
          :closeStashInfo="closeStashInfo"
          @closeAllStashInfo="closeAllStashInfo"
        />

        <div class="col-xl-4">
          <Card3 />
        </div>
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
// Utils
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'

// Services
import ApiService from '@/core/services/api.service'
import EventBus from '@/event-bus'

export default {
  name: 'Stash',
  data() {
    return {
      loading: false,
      quotaLoading: false,
      closeStashInfo: '',
      stashAccounts: '',
      stashServiceDetail: '',
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'global.stash',
        route: '/services/stash',
      },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        {
          title: 'global.services',
        },
        {
          title: 'global.stash',
          route: '/services/stash',
        },
      ],
      showSearch: false,
      showDetailButton: true,
      detailPlaceholder: 'detail.stash.createStash',
      externalButtonUrl: 'https://stash.plusclouds.com',
      externalButtonText: 'detail.stash.goToStash',
    })

    EventBus.$on(`subHeaderDetailOpen`, this.listener)
  },
  beforeDestroy() {
    EventBus.$off(`subHeaderDetailOpen`, this.listener)
  },
  created() {
    this.getStashAccountDetail()
    this.getStashService()
  },
  methods: {
    listener(payload) {
      this.$router.push(`/services/stash/wizard`)
    },
    getStashAccountDetail(onlyLoadQuota = false) {
      if (onlyLoadQuota) this.quotaLoading = true
      else this.loading = true

      ApiService.get(`stash/accounts`)
        .then(({ data }) => {
          if (data && data.data && data.data.length > 0) {
            this.stashAccounts = data.data
          }
          if (onlyLoadQuota) this.quotaLoading = false
          else this.loading = false
        })
        .catch((err) => {
          this.stashAccounts = ''
          if (onlyLoadQuota) this.quotaLoading = false
          else this.loading = false
        })
    },
    getStashService() {
      ApiService.get(`stash/services`)
        .then(({ data }) => {
          if (data && data.data && data.data.length > 0) {
            this.stashServiceDetail = data.data[0]
          }
        })
        .catch((err) => {})
    },
    closeAllStashInfo(payload) {
      this.closeStashInfo = payload
      setTimeout(() => {
        this.closeStashInfo = ''
      }, 100)
    },
  },
  components: {
    Card1: () => import('@/components/stash/v2/Card1'),
    Card2: () => import('@/components/stash/v2/Card2'),
    Card3: () => import('@/components/stash/v2/Card3'),
    StashInfo: () => import('@/components/stash/v2/StashInfo'),
    // CreateStashBanner: () => import('@/components/stash/CreateStashBanner'),
    // StorageUsage: () => import('@/components/stash/StorageUsage'),
    // LastActivities: () => import('@/components/stash/LastActivities'),
    // Users: () => import('@/components/stash/Users'),
    // Details: () => import('@/components/stash/Details'),
  },
}
</script>
